module.exports = __webpack_public_path__ + "static/media/1_pl.08d2209a.png";